import { Link, Step, StepLabel, Stepper, Typography } from "@mui/material";
import { useState } from "react";
import DisplayEmptyListAction from "../../../../../../components/DisplayEmptyListAction";
import { useModalDetalheTituloPagar } from "../../../MIContasPagar/ModalDetalheTituloContext";
import useSetParamsURL from "../../../../../../lib/useSetParamsURL";

export default function TitulosCompensados({ codigo, titulos }: TitulosCompensadosProps) {

    const {openModal} = useModalDetalheTituloPagar()
     const { clearSingleParamUrl } = useSetParamsURL();

    const handleCalStep = () => {
        if (!titulos) return 0
        return titulos.findIndex(item => item.codigo === codigo)
    }

    const [activeStep] = useState(handleCalStep());

    return (
        <>
            {
                (titulos?.length === 0) && (
                    <DisplayEmptyListAction
                        disabled
                        label="Nenhum título encontrado"
                    />
                )
            }   

            {
                titulos &&
                <Stepper activeStep={activeStep} orientation="vertical">
                    {
                        titulos.map((step) => {
                            return (
                                <Step key={step.numero_documento} completed={false}>
                                    <StepLabel>
                                        <Typography variant="subtitle2">
                                            <Link
                                                onClick={() =>{ 
                                                    clearSingleParamUrl("detalhe-titulo-receber");
                                                    openModal(`${step.tipo_publico}${step.codigo_publico}-${step.numero_documento}/${step.sequencia_documento} ${step.serie_documento}`)
                                                }}
                                                sx={{ cursor: "pointer" }}
                                            >
                                                {step.tipo_documento}-{step.numero_documento}/{step.sequencia_documento} {step.serie_documento}
                                            </Link>
                                        </Typography>
                                    </StepLabel>
                                </Step>
                            )
                        })
                    }
                </Stepper>
            }
        </>
    )
}

interface Titulo {
    codigo: string;
    tipo_documento: string;
    numero_documento: string;
    serie_documento: string;
    tipo_publico: string;
    codigo_publico: string;
    sequencia_documento: string;
}
  
interface TitulosCompensadosProps {
    codigo: string;
    titulos?: Titulo[] | null;
}